module.exports = __webpack_public_path__ + "assets/img/gar5-1.4ae5a3c2.jpg";